/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Vault_DescriptionInputs */

const en_document_vault_description = /** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing documentation and files`)
};

const id_document_vault_description = /** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi dan file listing`)
};

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const es_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const fr_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const de_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const ja_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const zh_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const ar_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const it_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const ru_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const pt_document_vault_description = en_document_vault_description;

/** @type {(inputs: Document_Vault_DescriptionInputs) => LocalizedString} */
const ko_document_vault_description = en_document_vault_description;

/**
* | output |
* | --- |
* | "Listing documentation and files" |
*
* @param {Document_Vault_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_vault_description = /** @type {((inputs?: Document_Vault_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Vault_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_vault_description(inputs)
	if (locale === "es") return es_document_vault_description(inputs)
	if (locale === "fr") return fr_document_vault_description(inputs)
	if (locale === "de") return de_document_vault_description(inputs)
	if (locale === "ja") return ja_document_vault_description(inputs)
	if (locale === "zh") return zh_document_vault_description(inputs)
	if (locale === "ar") return ar_document_vault_description(inputs)
	if (locale === "id") return id_document_vault_description(inputs)
	if (locale === "it") return it_document_vault_description(inputs)
	if (locale === "ru") return ru_document_vault_description(inputs)
	if (locale === "pt") return pt_document_vault_description(inputs)
	return ko_document_vault_description(inputs)
});